
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/CommunityPage/CommunityPage",
      function () {
        return require("private-next-pages/community/CommunityPage/CommunityPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/CommunityPage/CommunityPage"])
      });
    }
  